// Simulateur de cout (page "Remplacer mon tamis") — voir sections/rmt-simulateur.liquid.
// Pas de librairie de graph externe : polyline SVG en escalier tracee a la
// main (meme logique que le radar de assets/tamis-picker.js). Le cadre est
// suppose sain a chaque renouvellement Hexagon (hypothese affichee sous les
// resultats, jamais promise) ; les 200h sont une hypothese de calcul
// modifiable, pas une duree de vie prouvee.
//
// 2026-09-03 : trackEvent() relaie aussi vers window.HexagonAnalytics
// (Shopify.analytics.publish) — evenements sur 'change' (pas 'input'),
// donc pas de risque de spam clavier. Audit/mise en place analytics, brief
// dedie.
(function () {
  var root = document.querySelector('[data-rmt-sim-svg]');
  if (!root) return;

  var CFG = window.HexagonRmtSimConfig || { projectionAnnees: 5, heuresAvantRenouvellement: 160 };
  var heuresInput = document.querySelector('[data-rmt-sim-heures]');
  var heuresOut = document.getElementById('RmtSimHeuresOut');
  var prixInput = document.querySelector('[data-rmt-sim-prix-classique]');
  var configSelect = document.querySelector('[data-rmt-sim-config]');
  var svg = root;

  var levelSelect = document.querySelector('[data-rmt-sim-level]');
  var levelButtons = document.querySelectorAll('[data-rmt-sim-level-btn]');
  var referenceHoursOutput = document.querySelector('[data-rmt-sim-reference-hours]');
  var configPriceRaquetteEl = document.querySelector('[data-rmt-sim-config-price-raquette]');
  var configPriceTamisEl = document.querySelector('[data-rmt-sim-config-price-tamis]');
  var breakevenEl = document.querySelector('[data-rmt-sim-breakeven]');
  var chartScroll = document.querySelector('[data-rmt-sim-chart-scroll]');
  var cursorEl = document.querySelector('[data-rmt-sim-cursor]');
  var tooltipEl = document.querySelector('[data-rmt-sim-tooltip]');

  // 2026-09-15 : etat du dernier rendu, lu par le hover/touch du graphique
  // (onPointerMove plus bas) pour retrouver, a partir d'un mois quelconque
  // sous le curseur, le cout cumule de chaque scenario a cet instant — sans
  // recalculer toute la simulation a chaque mouvement de souris.
  var lastRender = null;

  // 2026-09-15 : "Rentable après X changement, soit Y mois" — premier
  // segment (meme decoupage que areaMarkup dans render()) ou le cout
  // cumule Hexagon repasse sous le cout cumule classique. `seg` a ce
  // point correspond exactement au nombre de remplacements de tamis deja
  // effectues (voir le commentaire sur segHexagon dans render()). Suppose
  // une comparaison monotone (l'ecart ne peut que croitre une fois que
  // Hexagon devient moins cher, tant que prixRemplacement < prixClassique,
  // cas normal) — pas de recherche du dernier croisement, seulement du 1er.
  function computeBreakeven(segmentBounds, prixClassique, prixRaquetteHexagon, prixRemplacement) {
    for (var seg = 0; seg < segmentBounds.length - 1; seg++) {
      var segClassique = prixClassique * (seg + 1);
      var segHexagon = prixRaquetteHexagon + seg * prixRemplacement;
      if (segHexagon <= segClassique) {
        return { seg: seg, mois: segmentBounds[seg] };
      }
    }
    return null;
  }

  function formatDuration(moisFloat) {
    var months = Math.round(moisFloat);
    if (months < 12) return months + ' mois';
    var years = Math.floor(months / 12);
    var remMonths = months % 12;
    var yearsLabel = years + (years > 1 ? ' ans' : ' an');
    return remMonths === 0 ? yearsLabel : yearsLabel + ' et ' + remMonths + ' mois';
  }

  // 2026-09-22 V6 ("changez la tournure de phrase 'Rentable dès le 1er...',
  // 'Rentable dès le 2eme changement de tamis'") : ordinal francais simple
  // (1er, puis Neme) — suffit pour l'usage ici (jamais au-dela d'une
  // poignee de renouvellements sur une periode de projection realiste).
  function ordinalFr(n) {
    return n === 1 ? '1er' : n + 'ème';
  }

  function renderBreakeven(breakeven, moisTotal) {
    if (!breakevenEl) return;
    if (!breakeven) {
      // 2026-09-22 V6 ("scenario non rentable : tu supprimes, tu ne mets
      // rien") : plus de message de repli — voir .rmt-sim__breakeven:empty
      // dans assets/base.css pour l'espace reserve, retire lui aussi.
      breakevenEl.textContent = '';
      return;
    }
    if (breakeven.seg === 0) {
      breakevenEl.innerHTML = '<strong>Rentable dès l’achat</strong> de la Raquette Hexagon avec ces paramètres.';
      return;
    }
    breakevenEl.innerHTML =
      'Rentable dès le <strong>' + ordinalFr(breakeven.seg) + ' changement de tamis</strong>, ' +
      'soit <strong>' + formatDuration(breakeven.mois) + '</strong>.';
  }

  // Cout cumule de chaque scenario a un mois donne (meme logique de
  // segment que areaMarkup/computeBreakeven, reutilisee pour la fenetre
  // contextuelle du graphique).
  function costsAtMois(mois) {
    var r = lastRender;
    var seg = 0;
    while (seg < r.segmentBounds.length - 1 && r.segmentBounds[seg + 1] < mois) seg++;
    return {
      classique: r.prixClassique * (seg + 1),
      hexagon: r.prixRaquetteHexagon + seg * r.prixRemplacement
    };
  }

  function hideTooltip() {
    if (cursorEl) cursorEl.hidden = true;
    if (tooltipEl) tooltipEl.hidden = true;
  }

  function onPointerMove(evt) {
    if (!lastRender || !svg) return;
    var rect = svg.getBoundingClientRect();
    if (!rect.width) return;
    // Pointer Events (mousemove/touch/stylet unifies) : clientX toujours
    // present, pas besoin de distinguer souris/touch ici.
    var frac = Math.min(Math.max((evt.clientX - rect.left) / rect.width, 0), 1);
    var mois = frac * lastRender.moisTotal;
    var costs = costsAtMois(mois);
    var ecart = costs.classique - costs.hexagon;

    // Position relative au CONTENU scrollable de .rmt-sim__chart-scroll
    // (pas au viewport) : reste correcte meme si le graphique est scrolle
    // horizontalement sur mobile (svg min-width 620px).
    var localX = frac * rect.width;
    if (cursorEl) {
      cursorEl.style.left = localX + 'px';
      cursorEl.hidden = false;
    }
    if (tooltipEl) {
      tooltipEl.innerHTML =
        '<span class="rmt-sim__tooltip-mois">Après ' + formatDuration(mois) + '</span>' +
        '<span class="rmt-sim__tooltip-row"><span>Raquette classique</span><span class="rmt-sim__tooltip-value">' + moneyFr(costs.classique) + '</span></span>' +
        '<span class="rmt-sim__tooltip-row"><span>Raquette Hexagon</span><span class="rmt-sim__tooltip-value">' + moneyFr(costs.hexagon) + '</span></span>' +
        '<span class="rmt-sim__tooltip-row is-ecart"><span>Écart</span><span class="rmt-sim__tooltip-value">' + moneyFr(Math.abs(ecart)) + '</span></span>';
      tooltipEl.hidden = false;
      // Clamp horizontal pour ne jamais deborder de .rmt-sim__chart-scroll
      // (le conteneur scrollable, pas le viewport — coherent avec `left`
      // calcule ci-dessus).
      var tooltipWidth = tooltipEl.offsetWidth;
      var containerWidth = chartScroll ? chartScroll.scrollWidth : rect.width;
      var tooltipLeft = Math.min(Math.max(localX - tooltipWidth / 2, 0), containerWidth - tooltipWidth);
      tooltipEl.style.left = tooltipLeft + 'px';
    }
  }

  function trackEvent(name, detail) {
    var fullName = 'hexagon:rmt-' + name;
    document.dispatchEvent(new CustomEvent(fullName, { detail: detail || {} }));
    if (window.HexagonAnalytics) window.HexagonAnalytics.publish(fullName, detail);
  }

  function moneyFr(n) {
    return Math.round(n).toLocaleString('fr-FR') + ' €';
  }

  // 2026-09-22 ("l'integralite du graphique doit tenir sur l'ecran sans
  // scroll") : remplace l'ancien x2 (qui ne montrait volontairement que la
  // moitie de la projection, brief du 2026-09-16 — devenu obsolete). Mesure
  // la largeur REELLEMENT disponible (chartScroll.clientWidth reste stable
  // meme quand le contenu deborde, grace a overflow-x:auto) et l'applique
  // telle quelle en style inline (un `width:100%` CSS pur ne se resolvait
  // pas correctement sur ce <svg>, element remplace imbrique dans un
  // parent flex — cf. base.css).
  //
  // 2026-09-22 V4 ("le graph n'est pas full bloc sur desktop, il y a une
  // barre de defilement") : etait actif seulement <=620px, laissant le
  // min-width:620px de base.css dominer au-dessus — des que la carte
  // Simulation (colonne droite) rend moins de 620px de large disponibles
  // (frequent sur les resolutions desktop/laptop intermediaires, d'autant
  // plus depuis l'elargissement de la colonne gauche), une barre de
  // defilement horizontale apparaissait meme en desktop. Le fit exact
  // s'applique desormais a TOUTE largeur d'ecran, plus de coupure a 620px.
  function fitChartWidth() {
    if (!chartScroll) return;
    var containerWidth = chartScroll.clientWidth;
    if (containerWidth > 0) svg.style.minWidth = containerWidth + 'px';
  }

  // 2026-09-05 (Lot 4 V4) : "pas de 263€/788€, des chiffres ronds finissant
  // par 0 ou 5" — l'axe € du graphique se calait auparavant sur des
  // fractions brutes du cout max reel (25/50/75%), donnant des valeurs
  // arbitraires. Calcule un pas "rond" (1/2/5/10 x une puissance de 10,
  // technique standard d'axe de graphique) puis un maximum d'axe = 4x ce
  // pas, TOUJOURS superieur ou egal au cout reel (le graphique garde donc
  // une petite marge en haut, normal pour ce type d'axe). Les couts
  // reels (paye) restent inchanges ailleurs (recap, totaux) — seule
  // l'ECHELLE du graphique et les reperes € en dependent.
  // 2026-09-22 ("resserre l'echelle, trop de vide en haut du graphique") :
  // l'ancienne liste de paliers (1/2/5/10) ne comptait que 4 valeurs
  // possibles par decade, donc le residu pouvait sauter tres au-dessus du
  // besoin reel (ex. residu 3.25 -> palier 5, soit +54% de marge une fois
  // multiplie par les 4 graduations) — c'est ce qui creait le grand vide
  // constate entre le haut du graphique et la 1ere ligne visible (75%).
  // Liste elargie (encore uniquement des valeurs qui, multipliees par une
  // puissance de 10, finissent par 0 ou 5 — contrainte du 2026-09-05 V4
  // conservee) : reduit l'ecart maximal entre le residu et le palier
  // choisi, donc moins de marge inutile en haut, sans jamais revenir a des
  // chiffres non ronds comme 263€/788€.
  var NICE_AXIS_RESIDUALS = [1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10];
  function niceAxisStep(maxValue, ticks) {
    if (maxValue <= 0) return 1;
    var rawStep = maxValue / ticks;
    var magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
    var residual = rawStep / magnitude;
    var niceResidual = NICE_AXIS_RESIDUALS[NICE_AXIS_RESIDUALS.length - 1];
    for (var i = 0; i < NICE_AXIS_RESIDUALS.length; i++) {
      if (NICE_AXIS_RESIDUALS[i] >= residual) {
        niceResidual = NICE_AXIS_RESIDUALS[i];
        break;
      }
    }
    return niceResidual * magnitude;
  }

  // Calcule les mois de renouvellement sur la periode de projection : un
  // renouvellement a lieu tous les X mois, X = heuresReference / (heures/semaine * 52/12).
  function computeSchedule(heuresSemaine, heuresReference) {
    var moisTotal = CFG.projectionAnnees * 12;
    var heuresParMois = heuresSemaine * (52 / 12);
    if (heuresParMois <= 0) return { intervalMois: null, renewalMonths: [] };
    var intervalMois = heuresReference / heuresParMois;
    var months = [];
    var m = intervalMois;
    while (m <= moisTotal + 0.001) {
      months.push(m);
      m += intervalMois;
    }
    return { intervalMois: intervalMois, renewalMonths: months };
  }

  // Serie de points (mois, cout cumule) formant un escalier : le cout reste
  // plat entre 2 renouvellements, puis saute au moment du renouvellement.
  function stepSeries(renewalMonths, startCost, stepCost, moisTotal) {
    var pts = [[0, startCost]];
    var cost = startCost;
    renewalMonths.forEach(function (m) {
      pts.push([m, cost]);
      cost += stepCost;
      pts.push([m, cost]);
    });
    pts.push([moisTotal, cost]);
    return { points: pts, total: cost };
  }

  function svgCoords(points, moisTotal, maxCost, w, h, padTop) {
    return points.map(function (p) {
      var x = (p[0] / moisTotal) * w;
      var y = padTop + (1 - (maxCost ? p[1] / maxCost : 0)) * (h - padTop);
      return [x, y];
    });
  }

  function svgPath(coords) {
    return coords.map(function (c, i) {
      return (i === 0 ? 'M' : 'L') + c[0].toFixed(1) + ',' + c[1].toFixed(1);
    }).join(' ');
  }

  function render() {
    var heures = parseFloat(heuresInput.value) || 1;
    var prixClassique = parseFloat(prixInput.value) || 0;
    var opt = configSelect.options[configSelect.selectedIndex];
    var prixRaquetteHexagon = parseFloat(opt.getAttribute('data-raquette')) || 0;
    var prixRemplacement = parseFloat(opt.getAttribute('data-remplacement')) || 0;

    if (heuresOut) heuresOut.textContent = heures;

    // 2026-09-09 ("sous les boutons de choix de la configuration Hexagon,
    // ajoute le prix de la raquette et le prix du tamis seul") : mis a
    // jour a chaque render() (donc a chaque clic sur Controle/Equilibre/
    // Puissance, meme mecanisme que le reste du simulateur).
    if (configPriceRaquetteEl) configPriceRaquetteEl.textContent = moneyFr(prixRaquetteHexagon);
    if (configPriceTamisEl) configPriceTamisEl.textContent = moneyFr(prixRemplacement);

    var levelOption = levelSelect ? levelSelect.options[levelSelect.selectedIndex] : null;
    var levelCoefficient = levelOption ? parseFloat(levelOption.getAttribute('data-coefficient')) || 1 : 1;
    var heuresReference = Math.round(CFG.heuresAvantRenouvellement * levelCoefficient);

    var moisTotal = CFG.projectionAnnees * 12;
    var schedule = computeSchedule(heures, heuresReference);

    // 2026-09-05 (Lot 4 V3) : le scenario classique doit lui aussi partir
    // d'un achat a t=0 (comparaison a parite avec Hexagon, qui part de
    // l'achat de la raquette Hexagon) — l'ancienne hypothese "la raquette
    // actuelle est deja possedee" faisait demarrer le cout classique a 0€,
    // ce qui sous-estimait son cout total et faussait la comparaison.
    // Rachat complet (prixClassique) a l'achat ET a chaque renouvellement.
    var classique = stepSeries(schedule.renewalMonths, prixClassique, prixClassique, moisTotal);
    // Hexagon : cout initial = achat de la raquette Hexagon (on bascule
    // maintenant), puis remplacement du tamis seul a chaque renouvellement.
    var hexagon = stepSeries(schedule.renewalMonths, prixRaquetteHexagon, prixRemplacement, moisTotal);

    var maxCost = Math.max(classique.total, hexagon.total, 1);
    // 2026-09-05 (Lot 4 V4) : axisMax (pas rond x4) remplace maxCost brut
    // pour toute l'echelle verticale du graphique — voir niceAxisStep()
    // plus haut. maxCost lui-meme reste inchange pour les usages hors
    // graphique (aucun ici, garde pour lisibilite du calcul).
    var axisStep = niceAxisStep(maxCost, 4);
    var axisMax = axisStep * 4;
    var w = 400, h = 220, padTop = 12;

    var classiqueCoords = svgCoords(classique.points, moisTotal, axisMax, w, h, padTop);
    var hexagonCoords = svgCoords(hexagon.points, moisTotal, axisMax, w, h, padTop);

    // Grille horizontale discrete (decoration statique, pas issue du calcul)
    // + zone teintee entre les 2 courbes ("zone d'ecart", brief §5.3 —
    // "sobre") : polygone classique aller + hexagon retour, rempli en
    // transparence derriere les 2 traits.
    var gridMarkup = [0.25, 0.5, 0.75].map(function (frac) {
      var y = (padTop + frac * (h - padTop)).toFixed(1);
      return '<line x1="0" y1="' + y + '" x2="' + w + '" y2="' + y + '" class="rmt-sim__grid" />';
    }).join('');

    // 2026-09-05 (Lot 4 V3) : la zone d'ecart n'est plus UN SEUL polygone
    // d'une seule couleur (choisie selon le signe de l'ecart FINAL) — elle
    // est decoupee en un rectangle par segment de l'escalier (classique et
    // hexagon partagent le meme calendrier de renouvellement, schedule.
    // renewalMonths, donc les memes bornes de segment), chacun colore selon
    // le signe LOCAL a ce segment. Un graphique ou Hexagon est d'abord plus
    // cher puis devient plus interessant affiche donc du gris puis du vert,
    // au lieu d'une seule couleur globale qui masquait ce changement.
    var segmentBounds = [0].concat(schedule.renewalMonths).concat([moisTotal]);

    // 2026-09-15 : etat lu par la fenetre contextuelle du graphique
    // (onPointerMove) et par renderBreakeven() ci-dessous.
    lastRender = {
      segmentBounds: segmentBounds,
      prixClassique: prixClassique,
      prixRaquetteHexagon: prixRaquetteHexagon,
      prixRemplacement: prixRemplacement,
      moisTotal: moisTotal
    };
    renderBreakeven(computeBreakeven(segmentBounds, prixClassique, prixRaquetteHexagon, prixRemplacement), moisTotal);
    hideTooltip();

    var areaMarkup = '';
    for (var seg = 0; seg < segmentBounds.length - 1; seg++) {
      var segClassique = prixClassique * (seg + 1);
      var segHexagon = prixRaquetteHexagon + seg * prixRemplacement;
      var x1 = (segmentBounds[seg] / moisTotal) * w;
      var x2 = (segmentBounds[seg + 1] / moisTotal) * w;
      var yClassique = padTop + (1 - segClassique / axisMax) * (h - padTop);
      var yHexagon = padTop + (1 - segHexagon / axisMax) * (h - padTop);
      var segClass = segHexagon <= segClassique ? 'rmt-sim__area--positif' : 'rmt-sim__area--negatif';
      areaMarkup +=
        '<rect x="' + x1.toFixed(1) + '" y="' + Math.min(yClassique, yHexagon).toFixed(1) +
        '" width="' + (x2 - x1).toFixed(1) + '" height="' + Math.abs(yHexagon - yClassique).toFixed(1) +
        '" class="' + segClass + '" />';
    }

    // 2026-09-05 (Lot 4 V2) : valeurs € des reperes de l'axe vertical —
    // memes fractions que gridMarkup ci-dessus (0.25/0.5/0.75 de la
    // hauteur = 0.75/0.5/0.25 de l'axe, cf. sections/rmt-simulateur.liquid
    // pour le positionnement CSS de ces spans aux memes hauteurs). "0 €"
    // est fixe dans le markup, pas mis a jour ici.
    // 2026-09-05 (Lot 4 V4) : axisMax*fracCost = axisStep, 2x, 3x — des
    // multiples exacts du pas rond calcule par niceAxisStep(), jamais des
    // fractions arbitraires du cout reel.
    [0.75, 0.5, 0.25].forEach(function (fracCost) {
      var el = document.querySelector('[data-rmt-sim-axis-y="' + fracCost + '"]');
      if (el) el.textContent = moneyFr(axisMax * fracCost);
    });

    var svgMarkup =
      gridMarkup +
      '<line x1="0" y1="' + (h - 1) + '" x2="' + w + '" y2="' + (h - 1) + '" class="rmt-sim__axis" />' +
      areaMarkup +
      '<path d="' + svgPath(classiqueCoords) + '" class="rmt-sim__line is-classique" />' +
      '<path d="' + svgPath(hexagonCoords) + '" class="rmt-sim__line is-hexagon" />';
    svg.innerHTML = svgMarkup;

    var totalClassiqueEl = document.querySelector('[data-rmt-sim-total-classique]');
    var totalHexagonEl = document.querySelector('[data-rmt-sim-total-hexagon]');
    // "Ecart estime" est affiche 2x dans la nouvelle mise en page (colonne
    // gauche + synthese sous le graphique, brief §5.3) : memes attributs,
    // on met a jour tous les elements correspondants.
    var ecartEls = document.querySelectorAll('[data-rmt-sim-ecart]');
    var renouvellementsEl = document.querySelector('[data-rmt-sim-renouvellements]');
    var intervalleEl = document.querySelector('[data-rmt-sim-intervalle]');

    if (totalClassiqueEl) totalClassiqueEl.textContent = moneyFr(classique.total);
    if (totalHexagonEl) totalHexagonEl.textContent = moneyFr(hexagon.total);
    if (ecartEls.length) {
      // 2026-09-05 (Lot 4) : "340 € en faveur d'Hexagon" -> "340 €
      // economises avec la Raquette Hexagon" (demande explicite) — cas
      // negatif (classique moins cher) laisse inchange, formulation
      // differente car ce n'est pas une economie.
      var ecart = classique.total - hexagon.total;
      var ecartText = moneyFr(Math.abs(ecart)) + (ecart >= 0 ? ' économisés avec la Raquette Hexagon' : ' en faveur du scénario classique');
      ecartEls.forEach(function (el) { el.textContent = ecartText; });
    }
    if (renouvellementsEl) renouvellementsEl.textContent = schedule.renewalMonths.length;
    if (intervalleEl) {
      intervalleEl.textContent = schedule.intervalMois
        ? Math.round(schedule.intervalMois) + ' mois'
        : '—';
    }

    if (referenceHoursOutput) {
      referenceHoursOutput.textContent = heuresReference + ' h';
    }

    fitChartWidth();
  }

  ['input', 'change'].forEach(function (evt) {
    [heuresInput, prixInput, configSelect, levelSelect].forEach(function (el) {
      if (el) {
        el.addEventListener(evt, render);
      }
    });
  });
  heuresInput.addEventListener('change', function () { trackEvent('sim-heures', { heures: heuresInput.value }); });
  prixInput.addEventListener('change', function () { trackEvent('sim-prix', { prix: prixInput.value }); });
  configSelect.addEventListener('change', function () { trackEvent('sim-config', { config: configSelect.value }); });
  if (levelSelect) {
    levelSelect.addEventListener('change', function () {
      trackEvent('sim-level', { level: levelSelect.value || 'non-renseigne' });
    });
  }

  // Brief V3 : le select natif "Configuration Hexagon" est remplace
  // visuellement par de petits boutons (comme le configurateur) — le select
  // reste dans le DOM (visually-hidden) pour ne pas toucher a la logique de
  // calcul existante, les boutons se contentent de piloter sa valeur.
  //
  // 2026-09-22 ("reprends exactement les boutons du configurateur") : les 3
  // boutons utilisent desormais les classes .option/.option--style du
  // configurateur (assets/base.css), dont l'etat selectionne est pilote par
  // l'attribut aria-pressed (pas une classe .is-active) — voir
  // makeOption()/renderStyleGroup() dans assets/configurateur.js pour le
  // meme mecanisme cote configurateur.
  var configButtons = document.querySelectorAll('[data-rmt-sim-config-btn]');
  configButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-rmt-sim-config-btn');
      configSelect.value = value;
      configButtons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      configSelect.dispatchEvent(new Event('change'));
    });
  });

  // Brief V4 : niveau de jeu facultatif, pilote lui aussi un select
  // visually-hidden — un second clic sur le niveau actif le desactive
  // (retour a la base de 160h).
  levelButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var value = button.getAttribute('data-rmt-sim-level-btn');
      var alreadyActive = button.classList.contains('is-active');

      levelSelect.value = alreadyActive ? '' : value;

      levelButtons.forEach(function (item) {
        item.classList.toggle('is-active', !alreadyActive && item === button);
      });

      levelSelect.dispatchEvent(new Event('change'));
    });
  });

  // 2026-09-15 ("fenetre contextuelle au rollover sur la courbe, ou au
  // touch sur mobile") : Pointer Events unifie souris/touch/stylet, un
  // seul jeu d'ecouteurs. Attaches sur .rmt-sim__chart-scroll (toute la
  // largeur scrollable, pas juste le <svg>) pour une zone de detection
  // plus confortable au doigt.
  if (chartScroll) {
    chartScroll.addEventListener('pointermove', onPointerMove);
    chartScroll.addEventListener('pointerdown', onPointerMove);
    chartScroll.addEventListener('pointerleave', hideTooltip);
    chartScroll.addEventListener('pointerup', hideTooltip);
    chartScroll.addEventListener('pointercancel', hideTooltip);
  }

  // Rotation d'ecran / redimensionnement : recalcule la largeur du
  // graphique (fitChartWidth, voir plus haut) sans repasser par tout
  // render() a chaque pixel — un simple resize ne change ni les couts ni
  // la courbe, seulement la place disponible.
  window.addEventListener('resize', fitChartWidth);

  // 2026-09-22 V4 ("le volet Votre renouvellement ne s'ouvre pas en
  // desktop") : meme mecanisme que assets/configurateur-mobile-folds.js —
  // le script inline synchrone de sections/rmt-simulateur.liquid pose deja
  // l'attribut natif "open" au 1er rendu si la largeur est >=901px ; ceci
  // prend le relai pour un redimensionnement/rotation d'ecran APRES coup
  // (franchissement du breakpoint dans un sens ou dans l'autre).
  var renewalFoldEls = document.querySelectorAll('#rmt-simulateur [data-config-fold]');
  if (renewalFoldEls.length) {
    var renewalFoldMql = window.matchMedia('(min-width: 901px)');
    var onRenewalFoldBreakpointChange = function (e) {
      renewalFoldEls.forEach(function (el) { el.open = e.matches; });
    };
    if (typeof renewalFoldMql.addEventListener === 'function') {
      renewalFoldMql.addEventListener('change', onRenewalFoldBreakpointChange);
    } else if (typeof renewalFoldMql.addListener === 'function') {
      // Safari < 14.
      renewalFoldMql.addListener(onRenewalFoldBreakpointChange);
    }
  }

  render();
  trackEvent('sim-view');
})();
